import { createFileRoute } from "@tanstack/react-router";
import { viewUrlParams } from "@/components/views/views-data";

/** The host reads no query keys here; the query string is the view's params. */
export const Route = createFileRoute(
	"/$owner/events/$eventId/-/views/$viewKey",
)({
	validateSearch: viewUrlParams,
});
